module.exports = __webpack_public_path__ + "img/cooleye.6c217243.svg";